// extracted by mini-css-extract-plugin
export var logoContainer = "Bank-module--logoContainer--e9fR+";